import { v4 as generateID } from '@lukeed/uuid';
import { predict } from '..';
import { buildAssignments, } from './utils/oneDimensionalAssignment/buildAssignments';
function checkAtomsAndDiaIDs(signals) {
    for (const signal of signals) {
        if (!signal.atoms)
            throw new Error('signal has not atoms property');
        if (!signal.diaIDs)
            throw new Error('signal has not diaIDs property');
        if (!signal.nbAtoms)
            throw new Error('signal has not nbAtoms property');
    }
}
function checkIntegration(ranges) {
    for (const range of ranges) {
        if (range.integration === undefined)
            range.integration = 0;
    }
    return ranges;
}
export async function get13CAssignments(ranges, molecule, options = {}) {
    const { restrictionByCS = {}, minScore = 1, maxSolutions = 10, nbAllowedUnAssigned = 0, timeout = 6000, predictionOptions = {}, } = options;
    if (!molecule) {
        throw new Error('It is needed a OCL molecule instance to assign');
    }
    const { spectra } = await predict(molecule, {
        predictOptions: {
            C: predictionOptions,
        },
    });
    const joinedSignals = spectra.carbon?.joinedSignals || [];
    checkAtomsAndDiaIDs(joinedSignals);
    const copyRanges = checkIntegration(ranges);
    const targets = {};
    for (const range of copyRanges) {
        const { id = generateID() } = range;
        targets[id] = JSON.parse(JSON.stringify(range));
    }
    return buildAssignments({
        restrictionByCS,
        timeout,
        minScore,
        nbAllowedUnAssigned,
        maxSolutions,
        targets,
        joinedSignals,
        useIntegrationRestriction: false,
    });
}
//# sourceMappingURL=get13CAssignments.js.map